import script from "./DatabaseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabaseDetails.vue?vue&type=script&setup=true&lang=js"

import "./DatabaseDetails.vue?vue&type=style&index=0&id=46e31813&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46e31813"]])

export default __exports__